import { useState } from "react";
import axios from "axios";
import baseUrl from '../api/utils';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const LicenceFileCreation = () => {
    const MySwal = withReactContent(Swal);
    const token = sessionStorage.getItem("token");

  const [formData, setFormData] = useState({
    companyName: "",
    productname: "",
    licenseType: "",
    maxUsers: "",
    modulesEnabled: "",
    validityDays: "",
});

    const presetByType = {
        free: { maxUsers: "1", modulesEnabled: "", validityDays: "30" },
        basic: { maxUsers: "3", modulesEnabled: "BULK_UPLOAD", validityDays: "365" },
        standard: { maxUsers: "5", modulesEnabled: "BULK_UPLOAD,GST", validityDays: "365" },
        professional: { maxUsers: "15", modulesEnabled: "BULK_UPLOAD,GST,MULTI_BRANCH", validityDays: "365" },
        enterprise: { maxUsers: "1000", modulesEnabled: "BULK_UPLOAD,GST,MULTI_BRANCH", validityDays: "365" },
        customized: { maxUsers: "", modulesEnabled: "", validityDays: "" },
    };

   const isValid = () => {
    return (
        formData.licenseType &&
        formData.companyName &&
        formData.productname &&
        formData.maxUsers !== "" &&
        formData.validityDays !== ""
    );
};

    const handleInputChange = (e) => {
        const { id, value } = e.target;

        if (!formData.licenseType && id !== "licenseType") {
            MySwal.fire({
                toast: true,
                position: 'top-end',
                icon: 'warning',
                title: 'Please Select a License Type First !',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
            return;
        }

        setFormData((prevData) => ({
            ...prevData,
            [id]: value || "",
        }));

        if (id === "licenseType") {
            const preset = presetByType[value];
            if (preset) {
                setFormData((prevData) => ({
                    ...prevData,
                    licenseType: value,
                    maxUsers: preset.maxUsers,
                    modulesEnabled: preset.modulesEnabled,
                    validityDays: preset.validityDays,
                }));
            } else {
                setFormData({
                    company: "",
                    companyName: "",
                    licenseType: "",
                    maxUsers: "",
                    productname:"",
                    modulesEnabled: "",
                    validityDays: "",
                });
            }
        }
    };

    const handleSubmit = async () => {
        if (!isValid()) {
            MySwal.fire({
                toast: true,
                position: 'top-end',
                icon: 'warning',
                title: 'Please Fill out all Required Fields !',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
            return;
        }
        try {
            const response = await axios.post(`${baseUrl}/api/v2/license/generate`, null, {
                params: formData,
                responseType: "blob",
                headers: {
                    "Authorization": token,
                    "Accept": "application/xml",
                },
            });
            const blob = new Blob([response.data], { type: "application/xml" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
link.download = `${formData.companyName.replace(/\s+/g, '_')}_license.xml`;            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            MySwal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'License file generated successfully!',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });
        } catch (error) {
            console.error("Error creating license file:", error);
            MySwal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Something Went Wrong Please Try again later !',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
        }
    };

    return (
        <div>
            <div className="page-header"></div>
            <div className="card">
                <div className="card-body">
                    <h4>License File Creation</h4>
                    <div className="pt-4">
                        <div className="form-group row">
                            <label htmlFor="licenseType" className="col-sm-3 col-form-label">
                                License Type <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-9">
                                <select
                                    id="licenseType"
                                    value={formData.licenseType || "*"}
                                    onChange={handleInputChange}
                                    className="form-control"
                                >
                                    <option value="*">Select Type</option>
                                    <option value="free">Free</option>
                                    <option value="basic">Basic</option>
                                    <option value="standard">Standard</option>
                                    <option value="professional">Professional</option>
                                    <option value="enterprise">Enterprise</option>
                                    <option value="customized">Customized</option>
                                </select>
                            </div>
                        </div>

                        {[
                        { id: "companyName", label: "Company Display Name", type: "text" },
                        { id: "productname", label: "Product Name", type: "text" },
                        { id: "maxUsers", label: "Max Users", type: "number" },
                        { id: "modulesEnabled", label: "Modules Enabled (comma separated)", type: "text" },
                        { id: "validityDays", label: "Validity (Days)", type: "number" },
                    ].map(({ id, label, type }) => (
                            <div className="form-group row" key={id}>
                                <label htmlFor={id} className="col-sm-3 col-form-label">
                                    {label} <span className="text-danger">*</span>
                                </label>
                                <div className="col-sm-9">
                                    <input
                                        type={type}
                                        id={id}
                                        placeholder={label}
                                        value={formData[id]}
                                        onChange={handleInputChange}
                                        className="form-control"
                                        disabled={!formData.licenseType}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="btngrp">
                        <button
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            disabled={!isValid()}
                        >
                            Create
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LicenceFileCreation;